// extracted by mini-css-extract-plugin
export default {"containprod":"ZL","containprod2":"aM","title":"bM","servings":"cM","recommendation":"eM","image":"fM","flavorswrap":"gM","flavorsgroupwrap":"hM","moredetailsWrap":"iM","infoWrap":"jM","price":"kM","regularPrice":"lM","netPrice":"mM","addtocartcontainer":"nM","error":"oM"};
    if(module.hot) {
      // 1713211522077
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  